import { render, staticRenderFns } from "./SnippetAccordionItem.vue?vue&type=template&id=1430ba35"
import script from "./SnippetAccordionItem.vue?vue&type=script&lang=js"
export * from "./SnippetAccordionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModulesIndex: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/modules/ModulesIndex.vue').default})
